import { UUID } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { SeasonType } from '@avantstay/arriere-clients/dist/arriereBackoffice'

export interface SelectionMapValues {
  name: string
  id: string
}

export interface SelectionMap {
  [key: string]: SelectionMapValues
}

export interface PropertiesSelectionMap {
  [key: string]: {
    name: string
    properties: SelectionMap
  }
}

export interface GeneralInfoFormValues {
  name: string
  description: string
  seasonType?: {
    label: string
    value: SeasonType
  }
  importRulesFrom: any
}

export interface DefinePeriodRulesFormValues {
  id?: UUID
  dateRange: string
  minStay: DaySelection[]
  allowCheckIn: DaySelection[]
  allowCheckOut: DaySelection[]
}

export interface DaySelection {
  label: string
  value: number
  isSelected: boolean
}

export enum SeasonTableViewType {
  allSeasons = 'all-seasons',
  seasonsPerGroup = 'seasons-per-group',
}
